﻿import * as Backbone from 'backbone';
import * as _ from 'underscore';

export var Model = Backbone.Model.extend({
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
    initialize: function () {
    },
});

export var Collection = Backbone.Collection.extend({
    model: Model,
    constructor: function () {
        Backbone.Collection.prototype.constructor.apply(this, arguments);
    },
    initialize: function () {
    },
    /*"sync": function (method, model, options) {
        if ((method == 'read')  && (options.filename)) {
            options.url = options.filename;
        }
        else if (method == 'read') {
            //options.url = config.webApiUrl() + '/mainjs/ImportFileLanguage/dummy/dummy/dummy/';
            //options.url = config.webApiUrl() + window.event4us.config.languageJson;
            //options.url =  config.languageJson();
        }
        return Backbone.sync(method, model, options);
    },
    parse:function(response, options) {
        return options.parseField ? response[options.parseField] : response;
    }*/
});







